import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { Footnote } from '@lichtblick/photon/molecules/footnote/footnote';
import { RichText } from '../../helpers/RichText';
const elementMappers = {
    p: ({ children })=>/*#__PURE__*/ _jsx(Text, {
            renderAs: "p",
            size: "xs",
            children: children
        })
};
export const MFootnote = ({ featureFlag, index, text, theme })=>{
    // TODO: optimizely feature flags are deprecated, check content for occurences, then remove
    if (featureFlag) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Footnote, {
        color: theme === 'light' ? 'Black' : 'White',
        index: index,
        children: /*#__PURE__*/ _jsx(RichText, {
            elementMappers: elementMappers,
            richText: text
        })
    });
};

//# sourceMappingURL=MFootnote.js.map